module.exports = __webpack_public_path__ + "static/media/8.8_wanliu.png";